<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="password-view container">
    <div class="breadcrumb-password-view py-3 row">
      <Breadcrumb />
    </div>
    <div class="wizard-voucher mb-3 row">
      <Wizzard current-page="pass" />
    </div>
    <div class="title-password-view text-start">
      <h1>Emissão de Certificado</h1>
    </div>
    <div class="description-password-view text-start">
      <p>Agora você precisa criar sua senha de emissão.</p>
    </div>
    <div class="content-password-view">
      <div class="d-flex flex-row row">
        <div class="col-12 col-md-6 d-none d-md-block text-start">
          <img alt="emitir-certificado" src="@/assets/images/criar-senha.svg" />
        </div>
        <div class="col-12 col-md-6">
          <div class="description-password-view d-flex text-start">
            <p>
              Sua senha deve ter entre
              <strong>8 e 12 caracteres</strong>
              , ter pelo menos uma letra
              <strong>maiúscula</strong>
              e uma letra
              <strong>minúscula</strong>
              e
              <strong>números</strong>.
              <strong>Anote sua senha em um lugar seguro!</strong>
            </p>
          </div>
          <div class="input-create-password">
            <Input
              v-model="password"
              label="Senha"
              icon="lock"
              :is-required="true"
              placeholder="Digite a senha"
              type="password"
            />
            <div class="d-flex justify-content-end mt-2">
              <span
                class="circle"
                :class="[
                  validation.minLength ? 'bg--success' : 'bg--grayscale-light',
                ]"
              >
                +8
              </span>
              <span
                class="mx-2 circle"
                :class="[
                  validation.uppercase ? 'bg--success' : 'bg--grayscale-light',
                ]"
              >
                A
              </span>
              <span
                class="circle"
                :class="[
                  validation.lowercase ? 'bg--success' : 'bg--grayscale-light',
                ]"
              >
                a
              </span>
              <span
                class="ms-2 circle"
                :class="[
                  validation.hasNumber ? 'bg--success' : 'bg--grayscale-light',
                ]"
              >
                123
              </span>
            </div>
            <div class="input-confirm-password col-12">
              <Input
                v-model="confirmPassword"
                label="Confirmação de senha"
                icon="lock"
                :is-required="true"
                placeholder="Confirme a senha"
                type="password"
                :error-log="error"
              />
              <div class="d-flex justify-content-end mt-2 row">
                <div class="col-xs-12 col-lg-4">
                  <button
                    class="btn w-100 d-flex justify-content-center align-items-center"
                    type="button"
                    :class="!isValid ? 'btn-secondary' : 'btn-primary'"
                    :disabled="!isValid"
                    @click="savePassword"
                  >
                    <div
                      class="d-flex flex-row justify-content-end align-items-center"
                    >
                      <span>Avançar</span>
                      <Icon name="arrow-right" class="ms-2" />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import Wizzard from '@/components/Molecules/Wizzard.vue'
  import { mapActions } from 'pinia'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'

  interface DataPassword {
    validation: {
      uppercase: boolean
      lowercase: boolean
      hasNumber: boolean
      minLength: boolean
    }
    password: string | null
    confirmPassword: string | null
    error: string
  }

  export default defineComponent({
    name: 'HomeView',
    components: {
      Icon,
      Input,
      Breadcrumb,
      Wizzard,
    },
    data: () =>
      ({
        validation: {
          uppercase: false,
          lowercase: false,
          hasNumber: false,
          minLength: false,
        },
        password: null,
        confirmPassword: null,
        error: '',
      }) as DataPassword,
    methods: {
      ...mapActions(useDynamicForms, ['setPassword']),
      ...mapActions(useRouteBirdId, ['setRouterDone']),
      checkSamePassword() {
        if (this.password !== this.confirmPassword) {
          this.error = 'As senhas não correspondem.'
        } else {
          this.error = ''
        }
      },
      savePassword() {
        this.checkSamePassword()
        if (this.error === '' && this.isValid && this.password) {
          this.setPassword(this.password)
          this.setRouterDone('pass')
          this.$router.push('/birdId/check')
        }
      },
    },
    computed: {
      isValid() {
        const { uppercase, lowercase, hasNumber, minLength } = this.validation
        return (
          uppercase &&
          lowercase &&
          hasNumber &&
          minLength &&
          this.confirmPassword &&
          !this.error
        )
      },
    },
    watch: {
      password(current: string) {
        const lastLetter = current.slice(-1)

        if (/[\\"/'/`/´]/g.test(lastLetter)) {
          this.error = 'caracter inválido'
        } else {
          this.error = ''
        }

        const lowerCaseLetters = /[a-z]/g
        if (current.match(lowerCaseLetters)) {
          this.validation.lowercase = true
        } else {
          this.validation.lowercase = false
        }
        const upperCaseLetters = /[A-Z]/g
        if (current.match(upperCaseLetters)) {
          this.validation.uppercase = true
        } else {
          this.validation.uppercase = false
        }
        const numbers = /[0-9]/g
        if (current.match(numbers)) {
          this.validation.hasNumber = true
        } else {
          this.validation.hasNumber = false
        }
        if (current.length >= 8) {
          this.validation.minLength = true
        } else {
          this.validation.minLength = false
        }

        if (current.length > 0 && this.confirmPassword) {
          this.checkSamePassword()
        }
      },
      confirmPassword(current: string) {
        if (current.length > 0) {
          this.checkSamePassword()
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      const useRouteBirdIdStore = useRouteBirdId()
      const dynamicFormsStore = useDynamicForms()
      const solicitationStore = useSolicitation()
      const routesDone = useRouteBirdIdStore.getRoutesDone

      if (!solicitationStore.getSolicitation.voucher) {
        return next('/')
      }
      if (!routesDone.form) {
        return next('/form')
      }
      if (dynamicFormsStore.getPassword) {
        return next('/birdId/check')
      }
      return next()
    },
  })
</script>

<style lang="stylus" scoped>
  .circle
    display: flex
    align-items: center
    justify-content: center
    align-self: center
    width: 32px;
    height: 32px;
    border-radius: 50%
</style>
